interface RatingPageNoResultsProps {
  searchQuery: string;
}

function RatingPageNoResults({ searchQuery }: RatingPageNoResultsProps) {
  return (
    <div className="container-md mx-auto relative pt-16 md:pt-20 2xl:px-0 lg:px-4 md:px-4 px-4 pb-20 text-brown">
      <div className="max-w-[62.5rem] text-center bg-blue-light rounded-[1.25rem] p-10 md:shadow-2xl">
        <div className="text-2xl md:text-[2.188rem] font-extrabold tracking-[0.01em] leading-[120%] mb-4 md:mb-6">
          По запросу "{searchQuery}" ничего не найдено.
        </div>
        <p className="text-base md:text-[1.125rem] leading-[150%] tracking-[0.01em]">
          Проверьте название сервиса и попробуйте еще раз, либо мы еще не
          проверяли этот сервис...
        </p>
      </div>
    </div>
  );
}

export default RatingPageNoResults;
